import mixin from '../../../../support/mixin'
import ScrollToErrorMixin from '../../../../support/scroll_to_error_mixin'
import SimpleAssessmentController from '../../simple_assessment_controller'

export default class extends mixin(
  SimpleAssessmentController,
  ScrollToErrorMixin
) {}
